export default __webpack_public_path__ + "206b572a77fec72ca3445aab11fa2870.png";